import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Space, Typography } from 'antd';

import Shelf from '@/components/shared/Shelf';
import { useSocketShouldUpdateCourses } from '@/hooks/useSocketUpdateCourses';
import { useGetPackagesQuery } from '@/services/package';
import styled, { StyledProp } from '@/styled';

import PackageCard from './PackageCard';

const Packages = ({ className }: StyledProp) => {
  const hasUpdated = useSocketShouldUpdateCourses();

  const { data, isFetching, refetch } = useGetPackagesQuery({ size: 20, page: 1 });
  const navigate = useNavigate();
  const handleClickSeeAll = () => {
    navigate('/pacotes');
  };

  useEffect(() => {
    refetch();
  }, [hasUpdated, refetch]);

  if (isFetching) return null;

  return (
    <>
      <Shelf
        shelfProps={{
          isFetching,
          index: 2
        }}
        className={className}
        carouselProps={{ slidesToShow: 4, spaceBetween: 16 }}
        title={
          <Space size={32}>
            <Typography.Title level={4} ellipsis>
              Meus Pacotes
            </Typography.Title>
            {data?.total_pages > 1 && (
              <Typography.Text className='shelfcarrousel-clickable-text' underline onClick={handleClickSeeAll}>
                Ver Todos
              </Typography.Text>
            )}
          </Space>
        }
      >
        {data?.data.map(coursePackage => (
          <swiper-slide key={coursePackage.id}>
            <PackageCard {...coursePackage} packageSize={coursePackage.sorted_courses.length} />
          </swiper-slide>
        ))}
      </Shelf>
    </>
  );
};

export default styled(Packages)`
  margin-bottom: ${({ theme }) => theme.space.pxToRem(36)};

  .shelfcarrousel-clickable-text {
    cursor: pointer;
  }

  .carouselNavigator-right,
  .carouselNavigator-left {
    height: 100%;
  }
`;
